import { defineStore } from 'pinia';
import i18n from '@/plugins/i18n';
import { ref } from 'vue';

const t = i18n.global.t;
export const useDialogStore = defineStore('dialog', () => {
    // State
    const title = ref('');
    const message = ref('');
    const actions = ref([]);
    const show = ref(false);

    // Actions
    function create({ title: newTitle, message: newMessage, actions: newActions }) {
        title.value = newTitle;
        message.value = newMessage;
        actions.value = newActions;
        show.value = true;
    }

    function clear() {
        show.value = false;
    }

    function confirm({
        message: confirmMessage,
        title: confirmTitle,
        onConfirm,
        action,
        confirmIcon,
        confirmVariant,
    }) {
        // Ensure dialog is cleared first
        clear();

        create({
            title: confirmTitle ?? t('common.confirm'),
            message: confirmMessage ?? t('common.are_you_sure'),
            actions: [
                {
                    variant: 'secondary',
                    text: t('common.cancel'),
                    handler: async () => clear(),
                },
                {
                    text: t('common.confirm'),
                    variant: confirmVariant ?? 'primary',
                    icon: confirmIcon ?? undefined,
                    handler: async () => {
                        await onConfirm();
                        clear();
                    },
                    ...action,
                },
            ],
        });
    }

    const $reset = () => {
        clear();
    };

    return {
        // State
        title,
        message,
        actions,
        show,

        // Actions
        create,
        clear,
        confirm,
        $reset,
    };
});
